/**
 * Width/height ratio of a custom-size print from its configurator options, or null
 * when the item has no explicit dimensions. A plain uploaded photo used to be shown
 * centre-cropped to a square, which misled customers ordering e.g. 36 x 77 cm.
 *
 * Lives outside the 'use client' preview component so server components (order
 * pages) can call it too.
 */
export function printAspectRatioFromOptions(options?: Record<string, unknown> | null): number | null {
  if (!options) return null;
  const width = Number(options.size_width ?? options.width);
  const height = Number(options.size_height ?? options.height);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
  return width / height;
}
